<template>
  <v-container fluid>
    <v-form v-model="formValidity">
      <v-row>
        <v-toolbar dense>
          <v-btn @click="$emit('user-pre-cancel')" text>Indietro</v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="!formValidity" @click="$emit('user-pre-added')" color="accent">Fine</v-btn>
        </v-toolbar>
      </v-row>
      <v-row>
        <v-col class="d-flex" cols="12" md="3">
          <v-select
            v-model="user.contagion"
            :items="contagion"
            label="Contagio"
            hint="Frequentazione persone già contagiate"
            persistent-hint
            outlined
            dense
            required
            :rules="requiredRules"
          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" md="3">
          <v-select
            v-model="user.onset"
            :items="onset"
            label="Da quanto tempo "
            hint="si sono presentati i sintomi"
            persistent-hint
            outlined
            dense
            required
            :rules="requiredRules"
          ></v-select>
        </v-col>
        <v-col cols="12" md="10" class="d-flex">
          <v-select
            v-model="user.preconditions"
            :items="preconditions"
            label="Stato Precendente di Salute"
            @change="OnChangePreconditions"
            :rules="atLeastOneRules"
            outlined
            dense
            required
            multiple
            chips
          ></v-select>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    OnChangePreconditions(e) {
      if (e.length === 0) {
        this.preconditions.forEach(p => (p.disabled = false));
      } else {
        const modalChoices = this.preconditions,
          modal = modalChoices.filter(v => v.modal || false)[0].value;
        if (e.includes(modal)) {
          this.preconditions
            .filter(p => p.value !== modal)
            .forEach(p => (p.disabled = true));
        } else {
          this.preconditions.filter(p => p.value === modal)[0].disabled = true;
        }
      }
    }
  },
  data: () => ({
    formValidity: false,
    requiredRules: [v => !!v || "Dato richiesto."],
    atLeastOneRules: [v => (!!v && v.length > 0) || "Dato richiesto."],
    contagion: [
      { value: "positive", text: "Tampone Positivo" },
      { value: "hospital", text: "Personale Ospedaliero" },
      { value: "public", text: "A contatto con il Pubblico" },
      { value: "probable", text: "Probabile" },
      { value: "possible", text: "Possibile" },
      { value: "unknown", text: "Incerto" }
    ],
    onset: [
      { value: 12, text: "12 ore" },
      { value: 24, text: "24 ore" },
      { value: 48, text: "2 gg" },
      { value: 72, text: "+3 gg" }
    ],
    preconditions: [
      { value: "normal", text: "Normale", modal: true },
      { value: "diabetic", text: "Diabetico" },
      { value: "cardio", text: "Patologia Cardiaca" },
      { value: "mobilityimpaired", text: "Ridotta mobilità" },
      { value: "therapy", text: "Terapie" }
    ]
  })
};
</script>
